// lib/ga/index.js
import ReactGA from "react-ga4";

export const initGA = () => {
  if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("G-NQ0MMBRF1D", {
    gaOptions: {
      cookie_domain: 'auto', // Important: auto-handles subdomains
    }
  });
}

};

export const logPageView = (url) => {
  ReactGA.send({ hitType: "pageview", page: url });
};
